/*
 * Kinsora Bundle Initialization
 *
 * Runs on product pages where window.KinsoraBundleConfig is set (i.e.
 * the product has bundle.necklace_product + bundle.pendant_product
 * metafields). The bundle PDP is the SAME main-product.liquid template
 * as a regular necklace — this script reshapes it into a bundle view:
 *
 *   1. Adds a "BUNDLE • Necklace + Pendant" eyebrow above the title
 *   2. Hides the "Necklace Only" tab (you can't buy half a bundle)
 *   3. Renames the "Build a Stack" tab to "Bundle"
 *   4. Activates Build a Stack mode on page load
 *   5. Shows the underlying necklace and pendant as the set contents
 *   6. Programmatically adds the pendant to the stack so customer sees
 *      the bundle pre-populated
 *   7. Overrides the add-to-cart button to add the native Shopify bundle
 *      parent as one qualifying BOGO product, plus any optional extras as
 *      separate qualifying products
 */
(function () {
    var cfg = window.KinsoraBundleConfig;
    if (!cfg || !cfg.isBundle) return;

    // Mark the page as a bundle PDP at script-execute time (before
    // DOMContentLoaded) so theme.js's generic addToCart() can short-circuit
    // out and not race our overrideAddToCart(). Without this flag, a customer
    // who clicked Add to Cart during the brief window between theme.js's
    // event-delegation listener attaching and our init() finishing would
    // trigger the regular addToCart() against a virtual bundle product that
    // has no real variants, producing a silent no-op.
    window.Kinsora = window.Kinsora || {};
    window.Kinsora.isBundlePDP = true;

    function el(html) {
        var d = document.createElement('div');
        d.innerHTML = html.trim();
        return d.firstChild;
    }

    function reframeTabs() {
        var necklaceTab = document.querySelector('.tab-selector .tab[data-tab="necklace"]');
        var stackTab = document.querySelector('.tab-selector .tab[data-tab="stack"]');
        if (necklaceTab) necklaceTab.style.display = 'none';
        if (stackTab) {
            // Find the text node and replace it
            for (var i = 0; i < stackTab.childNodes.length; i++) {
                if (stackTab.childNodes[i].nodeType === 3) {
                    stackTab.childNodes[i].nodeValue = ' Bundle ';
                    break;
                }
            }
            // Make sure it's active
            if (necklaceTab) necklaceTab.classList.remove('active');
            stackTab.classList.add('active');
        }
        // Switch to Build a Stack mode visually. NOTE: clear the inline display
        // back to empty string (NOT 'block') so the .form-area CSS rule's
        // display:flex + gap:16px between form-sections actually applies. Setting
        // inline display:block was killing the gap and making sections butt
        // together with no breathing room.
        var necklaceMode = document.getElementById('necklaceOnlyMode');
        var stackMode = document.getElementById('buildStackMode');
        if (necklaceMode) necklaceMode.style.display = 'none';
        if (stackMode) stackMode.style.display = '';
    }

    function getExtraItemPricesCents() {
        var prices = [];
        var wrappers = document.querySelectorAll('#buildStackMode .dropdown-wrapper');
        wrappers.forEach(function (w) {
            if (w.getAttribute('data-base-locked') === 'true') return;
            if (w.getAttribute('data-bundle-pendant') === 'true') return;
            var raw = parseInt(w.getAttribute('data-price-cents'), 10);
            if (!isNaN(raw) && raw > 0) { prices.push(raw); return; }
            var origEl = w.querySelector('.dropdown-price-original');
            var discEl = w.querySelector('.dropdown-price-discounted');
            var priceEl = origEl || discEl;
            if (!priceEl) return;
            var n = parseFloat(priceEl.textContent.replace(/[^0-9.]/g, ''));
            if (!isNaN(n)) prices.push(Math.round(n * 100));
        });
        return prices;
    }

    function currentLockedPrice(selector, fallback) {
        var wrapper = document.querySelector(selector);
        var value = wrapper ? parseInt(wrapper.getAttribute('data-price-cents'), 10) : NaN;
        return !isNaN(value) && value > 0 ? value : Math.max(0, Number(fallback) || 0);
    }

    function bundlePricingContext() {
        var componentPrices = [
            currentLockedPrice('#buildStackMode .dropdown-wrapper--locked[data-base-locked="true"][data-type="necklace"]', cfg.necklace.price),
            currentLockedPrice('#buildStackMode .dropdown-wrapper--locked[data-bundle-pendant="true"]', cfg.pendant.price)
        ].filter(function(value) { return value > 0; });
        var setListPrice = Math.max(0, Number(cfg.parentPrice) || 0);
        var extraPrices = getExtraItemPricesCents();
        var pendingPrices = [setListPrice].concat(extraPrices).filter(function(value) { return value > 0; });
        var priceState = window.Kinsora && window.Kinsora.bogo && window.Kinsora.bogo.projectPrices
            ? window.Kinsora.bogo.projectPrices(pendingPrices)
            : null;
        var freeIndexes = window.Kinsora && window.Kinsora.bogo && window.Kinsora.bogo.pendingFreeIndexes
            ? window.Kinsora.bogo.pendingFreeIndexes(pendingPrices, priceState)
            : pendingPrices.map(function(value, index) {
                var sorted = pendingPrices.map(function(price, itemIndex) { return { price: price, index: itemIndex }; })
                    .sort(function(a, b) { return a.price - b.price; });
                return sorted.slice(0, Math.floor(sorted.length / 2)).some(function(item) { return item.index === index; });
            });
        return {
            pendingPrices: pendingPrices,
            componentPrices: componentPrices,
            extraPrices: extraPrices,
            setListPrice: setListPrice,
            listPrice: setListPrice + extraPrices.reduce(function(sum, value) { return sum + value; }, 0),
            priceState: priceState,
            freeIndexes: freeIndexes,
            pendingPayCents: pendingPrices.reduce(function(sum, price, index) {
                return sum + (freeIndexes[index] === true ? 0 : price);
            }, 0)
        };
    }

    function updateBundlePriceDisplay(context) {
        var priceEl = document.querySelector('.product-section .product-price');
        if (!priceEl) return;

        context = context || bundlePricingContext();
        var pendingPrices = context.pendingPrices;
        var listCents = context.listPrice;
        if (!listCents) return;
        var priceState = context.priceState;
        var discountedCents = Math.max(0, Number(context.pendingPayCents == null ? listCents : context.pendingPayCents) || 0);
        var bogoSavings = Math.max(0, listCents - discountedCents);

        function fmt(cents) {
            return (window.Kinsora && window.Kinsora.formatMoney)
                ? window.Kinsora.formatMoney(cents)
                : '$' + (cents / 100).toFixed(2);
        }

        var currentEl = priceEl.querySelector('.price-current');
        var compareEl = priceEl.querySelector('.price-compare');
        var saveEl = priceEl.querySelector('.price-save');

        if (!currentEl) {
            // No price-current span — bail rather than wreck the markup
            return;
        }

        // Create compare + save if Liquid didn't (the bundle has no compare_at)
        if (!compareEl) {
            compareEl = document.createElement('span');
            compareEl.className = 'price-compare';
            priceEl.insertBefore(compareEl, currentEl);
        }
        if (!saveEl) {
            saveEl = document.createElement('span');
            saveEl.className = 'price-save';
            priceEl.appendChild(saveEl);
        }

        if (bogoSavings > 0) {
            currentEl.textContent = fmt(discountedCents);
            compareEl.textContent = fmt(listCents);
            compareEl.style.display = 'inline';
            saveEl.textContent = 'YOU SAVE ' + fmt(bogoSavings);
            saveEl.style.display = 'inline';
        } else {
            currentEl.textContent = fmt(listCents);
            compareEl.style.display = 'none';
            saveEl.style.display = 'none';
        }
    }

    function formatBundleMoney(cents) {
        return (window.Kinsora && window.Kinsora.formatMoney)
            ? window.Kinsora.formatMoney(cents)
            : '$' + (cents / 100).toFixed(2);
    }

    function renderPriceElements(pricesEl, fullCents, isFree) {
        if (!pricesEl) return;
        pricesEl.textContent = '';
        pricesEl.removeAttribute('aria-label');
        if (isFree) {
            var originalEl = document.createElement('span');
            originalEl.className = 'dropdown-price-original';
            originalEl.textContent = formatBundleMoney(fullCents);
            var freeEl = document.createElement('span');
            freeEl.className = 'dropdown-price-discounted dropdown-price-free';
            freeEl.textContent = 'FREE';
            pricesEl.setAttribute('aria-label', formatBundleMoney(fullCents) + ', free with buy one get one');
            pricesEl.appendChild(originalEl);
            pricesEl.appendChild(freeEl);
        } else {
            var currentEl = document.createElement('span');
            currentEl.className = 'dropdown-price-discounted';
            currentEl.textContent = formatBundleMoney(fullCents);
            pricesEl.appendChild(currentEl);
        }
    }

    function renderLockedCardPrice(nameEl, title, fullCents, isFree) {
        if (!nameEl) return;
        nameEl.textContent = '';
        nameEl.appendChild(document.createTextNode(title + ' '));
        var pricesEl = document.createElement('span');
        pricesEl.className = 'dropdown-prices';
        renderPriceElements(pricesEl, fullCents, isFree);
        nameEl.appendChild(pricesEl);
        var wrapper = nameEl.closest('.dropdown-wrapper');
        if (wrapper) wrapper.setAttribute('data-bogo-projected-free', isFree ? 'true' : 'false');
    }

    function updateLockedCardPrices(context) {
        context = context || bundlePricingContext();
        var necklaceWrapper = document.querySelector('#buildStackMode .dropdown-wrapper--locked[data-base-locked="true"][data-type="necklace"]');
        if (necklaceWrapper) {
            renderLockedCardPrice(
                necklaceWrapper.querySelector('.product-dropdown-name'),
                cfg.necklace.title,
                context.componentPrices[0] || cfg.necklace.price,
                false
            );
        }
        var pendantWrapper = document.querySelector('#buildStackMode .dropdown-wrapper--locked[data-bundle-pendant="true"]');
        if (pendantWrapper) {
            renderLockedCardPrice(
                pendantWrapper.querySelector('.product-dropdown-name'),
                cfg.pendant.title,
                context.componentPrices[1] || cfg.pendant.price,
                false
            );
        }
        var extras = Array.prototype.filter.call(
            document.querySelectorAll('#buildStackMode .dropdown-wrapper'),
            function(wrapper) {
                return wrapper.getAttribute('data-base-locked') !== 'true' && wrapper.getAttribute('data-bundle-pendant') !== 'true';
            }
        );
        extras.forEach(function(wrapper, index) {
            var priceIndex = 1 + index;
            var price = context.extraPrices[index];
            if (!price) return;
            renderPriceElements(wrapper.querySelector('.dropdown-prices'), price, context.freeIndexes[priceIndex] === true);
            wrapper.setAttribute('data-bogo-projected-free', context.freeIndexes[priceIndex] === true ? 'true' : 'false');
        });
    }

    function updateBundleCta(context) {
        var button = document.querySelector('button.add-to-cart[data-action="add-to-cart"]');
        if (!button || button.disabled) return;
        context = context || bundlePricingContext();
        var extraCount = context.extraPrices.length;
        var priceState = context.priceState;
        var total = Math.max(0, Number(context.pendingPayCents == null
            ? context.pendingPrices.reduce(function(sum, value) { return sum + value; }, 0)
            : context.pendingPayCents) || 0);
        var label = extraCount === 0
            ? 'ADD SET TO CART'
            : 'ADD SET + ' + extraCount + ' ' + (extraCount === 1 ? 'PIECE' : 'PIECES') + ' TO CART';
        button.textContent = label + ' — ' + formatBundleMoney(total);
    }

    function collapseEmptyItemContainers() {
        // The CSS rule #...Items:not(:has(*)) { display: none } handles the
        // empty-container collapse on its own in modern browsers. We watch the
        // containers with a MutationObserver so that if theme.js later adds an
        // item (via "Add Another Necklace" / "Add Pendant" clicks), the
        // container becomes visible again and no stale inline style blocks it.
        ['secondaryNecklaceItems', 'pendantItems', 'necklacePendantItems'].forEach(function (id) {
            var el = document.getElementById(id);
            if (!el) return;
            var sync = function () {
                if (el.querySelector('*')) {
                    el.style.removeProperty('display');
                } else {
                    el.style.display = 'none';
                }
            };
            sync();
            new MutationObserver(sync).observe(el, { childList: true });
        });
    }

    function swapBaseNecklaceCard() {
        var wrapper = document.querySelector('#buildStackMode .dropdown-wrapper--locked[data-base-locked="true"]');
        if (!wrapper) return;

        // If Liquid already rendered the locked base card with the underlying
        // necklace's data (data-base-handle matches cfg.necklace.handle), we
        // have nothing to swap -- this is the no-flicker path. Keep the hidden
        // product form pointed at the native bundle parent for payment terms
        // and any accelerated checkout integration.
        var liquidPreRendered = wrapper.getAttribute('data-base-handle') === cfg.necklace.handle;
        if (liquidPreRendered) {
            var variantInput0 = document.getElementById('variantIdInput');
            if (variantInput0) variantInput0.value = cfg.parentVariantId;
            return;
        }

        // Fallback path: Liquid rendered the bundle product's own data and we
        // need to swap it client-side. Produces a brief flicker.
        var thumb = wrapper.querySelector('.product-dropdown-thumb');
        if (thumb && cfg.necklace.image) {
            thumb.innerHTML = '<img src="' + cfg.necklace.image + '" alt="' + cfg.necklace.title.replace(/"/g, '&quot;') + '" width="200" height="200" loading="lazy" style="width:100%;height:100%;object-fit:cover;">';
        }
        var nameEl = wrapper.querySelector('.product-dropdown-name');
        if (nameEl) {
            var priceHtml = '<span class="dropdown-prices"><span class="dropdown-price-discounted">' + cfg.necklace.priceFormatted + '</span></span>';
            nameEl.innerHTML = cfg.necklace.title + ' ' + priceHtml;
        }
        var subtitleEl = wrapper.querySelector('.product-dropdown-subtitle');
        if (subtitleEl) {
            subtitleEl.textContent = (window.Kinsora && window.Kinsora.bundleIncludedLabel) || 'Included in this bundle';
        }
        wrapper.setAttribute('data-base-handle', cfg.necklace.handle);
        wrapper.setAttribute('data-variant-id', cfg.necklace.variantId);
        wrapper.setAttribute('data-price-cents', cfg.necklace.price);
        wrapper.setAttribute('data-price-unit', 'cents');
        var variantInput = document.getElementById('variantIdInput');
        if (variantInput) variantInput.value = cfg.parentVariantId;
    }

    function injectPendantSlot() {
        // Build the pendant item DOM, mirroring the structure theme.js renders
        // for an added pendant. Locked, with variant pickers, with the bundle's
        // pendant pre-selected.
        var container = document.getElementById('pendantItems');
        if (!container) return;

        // If Liquid already rendered the locked pendant card (no-flicker path),
        // skip the JS injection -- just fall through to the variant-pill
        // renderer below. Without this guard, we'd double-insert the card on
        // every init() run.
        var alreadyThere = container.querySelector('[data-bundle-pendant="true"]');
        if (!alreadyThere) {
            // NOTE: The dropdown-wrapper--locked class + data-base-locked="true" are
            // what theme.js's pendant-picker uses to identify the base product, so it
            // can gray out the bundle's pendant in the "Add Pendant" dropdown list
            // and stop the customer from picking the same pendant twice.
            //
            // Build via DOM API (createElement + textContent) instead of an
            // HTML string so any '<', '>', '&', or quotes in cfg.pendant.title
            // can't break the markup or open an XSS hole. Safer than the
            // previous innerHTML approach which only escaped quotes.
            var wrapperEl = document.createElement('div');
            wrapperEl.className = 'dropdown-wrapper dropdown-wrapper--locked';
            wrapperEl.setAttribute('data-type', 'pendant');
            wrapperEl.setAttribute('data-base-locked', 'true');
            wrapperEl.setAttribute('data-bundle-pendant', 'true');
            wrapperEl.setAttribute('data-variant-id', cfg.pendant.variantId);
            wrapperEl.setAttribute('data-base-handle', cfg.pendant.handle);
            wrapperEl.setAttribute('data-price-cents', cfg.pendant.price);
            wrapperEl.setAttribute('data-price-unit', 'cents');

            var dropdownEl = document.createElement('div');
            dropdownEl.className = 'product-dropdown product-dropdown--locked';

            var thumbEl = document.createElement('div');
            thumbEl.className = 'product-dropdown-thumb';
            var imgEl = document.createElement('img');
            imgEl.src = cfg.pendant.image;
            imgEl.alt = cfg.pendant.title;
            thumbEl.appendChild(imgEl);

            var contentEl = document.createElement('div');
            contentEl.className = 'product-dropdown-content';

            var nameEl = document.createElement('div');
            nameEl.className = 'product-dropdown-name';
            nameEl.appendChild(document.createTextNode(cfg.pendant.title + ' '));
            var pricesEl = document.createElement('span');
            pricesEl.className = 'dropdown-prices';
            var priceEl = document.createElement('span');
            priceEl.className = 'dropdown-price-discounted';
            priceEl.textContent = cfg.pendant.priceFormatted;
            pricesEl.appendChild(priceEl);
            nameEl.appendChild(pricesEl);

            var subtitleEl = document.createElement('div');
            subtitleEl.className = 'product-dropdown-subtitle';
            subtitleEl.textContent = (window.Kinsora && window.Kinsora.bundleIncludedLabel) || 'Included in this bundle';

            contentEl.appendChild(nameEl);
            contentEl.appendChild(subtitleEl);
            dropdownEl.appendChild(thumbEl);
            dropdownEl.appendChild(contentEl);
            wrapperEl.appendChild(dropdownEl);
            container.appendChild(wrapperEl);
        }

        // Render the variant pickers (Metal / Length etc.) BELOW the injected
        // pendant card, the same way the locked necklace gets them. theme.js's
        // init pass at module-load time iterates [data-selected] wrappers to
        // call renderVariantPills, but our pendant slot is injected AFTER that
        // pass and uses data-base-handle (not data-selected), so it gets
        // skipped.
        //
        // Retry-with-backoff because the pendant_collection JSON in
        // main-product.liquid is rendered as an inline script -- depending on
        // load order, window.Kinsora.pendants may not be populated yet when
        // bundle-init's init() runs. A few short retries cover that race.
        var injected = container.querySelector('[data-bundle-pendant="true"]');
        if (!injected) {
            console.error('[KinsoraBundleInit] pendant slot not found after insert -- selector mismatch');
            return;
        }

        function tryRenderPendantPills(attempt) {
            var pills = window.renderVariantPills;
            var pendants = (window.Kinsora && window.Kinsora.pendants) || [];
            var found = pendants.find(function (p) { return p.handle === cfg.pendant.handle; });

            if (typeof pills !== 'function') {
                if (attempt < 10) {
                    setTimeout(function () { tryRenderPendantPills(attempt + 1); }, 50);
                } else {
                    console.error('[KinsoraBundleInit] window.renderVariantPills never became a function');
                }
                return;
            }
            if (!found) {
                if (attempt < 10) {
                    setTimeout(function () { tryRenderPendantPills(attempt + 1); }, 50);
                } else {
                    console.error('[KinsoraBundleInit] pendant', cfg.pendant.handle, 'not found in window.Kinsora.pendants', pendants.map(function (p) { return p.handle; }));
                }
                return;
            }
            pills(injected);
        }
        tryRenderPendantPills(0);

        // NOTE: the "Add Pendant" button is intentionally left visible — the bundle's
        // bundled pendant is locked in, but customers should still be able to add MORE
        // pendants to complete additional BOGO pairs.
    }

    function collectAddedSecondaries() {
        // Find any additional dropdown-wrappers the customer added via the
        // "Add Another Necklace" / "Add Pendant" upsells. These are siblings of
        // our locked base / locked pendant cards, NOT the locked ones themselves.
        var items = [];
        var wrappers = document.querySelectorAll('#buildStackMode .dropdown-wrapper');
        wrappers.forEach(function (w) {
            // Skip the locked base necklace (it's already in items as the bundle's necklace)
            if (w.getAttribute('data-base-locked') === 'true') return;
            // Skip the locked bundle pendant (it's already in items as the bundle's pendant)
            if (w.getAttribute('data-bundle-pendant') === 'true') return;
            var vid = w.getAttribute('data-variant-id');
            if (!vid) return;
            var type = w.getAttribute('data-type') || 'item';
            items.push({
                id: parseInt(vid, 10),
                quantity: 1,
                properties: {
                    _bundle_origin: cfg.bundleHandle,
                    _bundle_role: 'extra_' + type
                }
            });
        });
        return items;
    }

    // Lightweight visible toast — used to surface bundle add failures that
    // would otherwise be silent (button just reverts to ADD TO CART). Without
    // this, "I clicked, nothing happened" gives the customer no recourse.
    function showBundleToast(msg) {
        var existing = document.getElementById('kinsora-bundle-toast');
        if (existing) existing.remove();
        var t = document.createElement('div');
        t.id = 'kinsora-bundle-toast';
        t.textContent = msg;
        t.style.cssText = 'position:fixed;bottom:24px;left:50%;transform:translateX(-50%);background:#333;color:#fff;padding:12px 24px;border-radius:6px;font-family:var(--font-body,"Newsreader",Georgia,"Times New Roman",serif);font-size:13px;letter-spacing:0.02em;z-index:99999;opacity:0;transition:opacity 0.3s ease;';
        document.body.appendChild(t);
        requestAnimationFrame(function () { t.style.opacity = '1'; });
        setTimeout(function () { t.style.opacity = '0'; setTimeout(function () { t.remove(); }, 300); }, 3500);
    }

    function overrideAddToCart() {
        // Install the bundle ATC override unconditionally so the button works
        // in BOTH the storefront and the Shopify Theme Editor preview. Earlier
        // versions bailed in designMode to dodge cloneNode-vs-section-select
        // glitches, but that left the editor preview's ATC dead, which is
        // worse than the glitch. Re-add a designMode bail here only if a
        // real editor regression returns.
        var btn = document.querySelector('button.add-to-cart[data-action="add-to-cart"]');
        if (!btn) {
            console.error('[KinsoraBundleInit] no ATC button found -- selector "button.add-to-cart[data-action=\\"add-to-cart\\"]" matched nothing');
            return;
        }
        // Replace the button with a clone to drop existing listeners from theme.js
        var clone = btn.cloneNode(true);
        btn.parentNode.replaceChild(clone, btn);
        clone.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var originalText = clone.textContent;
            clone.disabled = true;
            clone.textContent = (window.Kinsora && window.Kinsora.bundleAddingLabel) || 'Adding...';

            // Submit the native Shopify bundle parent. Shopify expands its
            // components for inventory and fulfillment while the automatic
            // BOGO discount evaluates the complete set as one cart product.
            var parentVariantId = parseInt(cfg.parentVariantId, 10);

            // Validate the variant IDs BEFORE firing the fetch. parseInt('', 10)
            // returns NaN, and Shopify rejects items[].id of NaN/undefined with
            // a generic 422 that's hard to debug. Catch it here with a clear log.
            if (!parentVariantId || isNaN(parentVariantId)) {
                console.error('[KinsoraBundleInit] bad native bundle parent variant ID', { parentVariantId: parentVariantId });
                showBundleToast((window.Kinsora && window.Kinsora.bundleErrorLabel) || 'Something went wrong reading the bundle items. Please reload the page.');
                clone.textContent = originalText;
                clone.disabled = false;
                return;
            }

            var items = [{ id: parentVariantId, quantity: 1 }].concat(collectAddedSecondaries());

            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: items })
            })
            .then(function (r) {
                // Shopify returns 422 with a JSON body on most errors. Pull the
                // body either way so we can log/display it for debugging.
                return r.text().then(function (body) {
                    var parsed;
                    try { parsed = JSON.parse(body); } catch (e) { parsed = null; }
                    return { ok: r.ok, status: r.status, body: body, json: parsed };
                });
            })
            .then(function (resp) {
                if (!resp.ok || (resp.json && resp.json.status)) {
                    var msg = (resp.json && (resp.json.description || resp.json.message)) || ('Cart add failed: ' + resp.status);
                    console.error('[KinsoraBundleInit] /cart/add.js error', resp);
                    showBundleToast(msg);
                    clone.textContent = originalText;
                    clone.disabled = false;
                    return;
                }
                // Open the drawer AND refresh its contents from /cart.js -- the
                // open-cart action in theme.js only opens the drawer, it doesn't
                // refetch the cart, so without an explicit refresh the customer
                // would see stale items until they reload the page.
                if (window.Kinsora && typeof window.Kinsora.openCart === 'function') {
                    window.Kinsora.openCart();
                } else {
                    var openCartBtn = document.querySelector('[data-action="open-cart"]');
                    if (openCartBtn) openCartBtn.click();
                }
                if (window.Kinsora && typeof window.Kinsora.refreshCartDrawer === 'function') {
                    window.Kinsora.refreshCartDrawer();
                }
                setTimeout(function () {
                    clone.textContent = originalText;
                    clone.disabled = false;
                }, 1500);
            })
            .catch(function (err) {
                console.error('[KinsoraBundleInit] fetch failed', err);
                showBundleToast('Couldn’t add to cart. Please try again.');
                clone.textContent = originalText;
                clone.disabled = false;
            });
        });

        // The sticky CTA is a second button outside the cloned buy box. Route
        // it through the same native-parent add path.
        var stickyButton = document.querySelector('#stickyATC .sticky-atc__btn[data-action="add-to-cart"]');
        if (stickyButton) {
            stickyButton.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                if (!clone.disabled) clone.click();
            });
        }
    }

    function swapHeroImage() {
        // Only swap the hero image to the necklace's photo if the bundle
        // product itself has NO featured image (Shopify would otherwise render
        // a placeholder SVG). Once a bundle has its own real hero photo
        // uploaded via productCreateMedia, we leave it alone so the customer
        // sees the actual bundle composition photo, not the underlying chain.
        var placeholder = document.querySelector('.main-image .product-placeholder-img, .main-image svg.placeholder-svg');
        if (!placeholder) return; // Bundle has a real image — don't touch it
        if (!cfg.necklace.image) return;
        var img = document.createElement('img');
        img.id = 'mainImage';
        img.src = cfg.necklace.image;
        img.alt = cfg.necklace.title;
        img.width = 1200;
        img.height = 1200;
        if (placeholder.parentNode) placeholder.parentNode.replaceChild(img, placeholder);
        // Also expose the necklace's images to theme.js so dot/thumbnail clicks
        // work in the fallback case
        if (cfg.necklace.galleryImages && cfg.necklace.galleryImages.length) {
            window.Kinsora = window.Kinsora || {};
            window.Kinsora.productImages = cfg.necklace.galleryImages;
        }
    }

    // Exposed so theme.js can re-trigger the bundle price math when any
    // variant / option change happens on a wrapper. Without this, picking a
    // different metal or length would call theme.js's updatePriceDisplay
    // which overwrites the bundle total with the flat product.price ($85)
    // and nukes the slash + Save badge.
    function refreshBundlePrice() {
        var context = bundlePricingContext();
        updateBundlePriceDisplay(context);
        updateLockedCardPrices(context);
        updateBundleCta(context);
    }

    // Golden confetti fires once when a newly completed pair earns another
    // free item, anchored to the bundle BOGO progress bar.
    var _bundleLastFreeCount = 0;
    var _bundleProgressInitialized = false;
    function fireBundleMaxTierConfetti(bar) {
        try {
            if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        } catch (e) { /* no-op */ }

        var goldColors = ['#F0D08A', '#C1A46E', '#9A8154', '#FCEEC0', '#ECCB85', '#FAE3A8', '#D4B580'];

        function fire() {
            if (typeof window.confetti !== 'function') return;
            // Origin: the center of the progress bar so the explosion bursts
            // FROM the milestone the customer just hit.
            var originX = 0.5;
            var originY = 0.4;
            if (bar) {
                var rect = bar.getBoundingClientRect();
                if (rect.width > 0 && rect.height > 0) {
                    originX = (rect.left + rect.width / 2) / window.innerWidth;
                    originY = (rect.top + rect.height / 2) / window.innerHeight;
                }
            }
            window.confetti({
                particleCount: 160,
                angle: 270,
                spread: 110,
                startVelocity: 40,
                decay: 0.92,
                gravity: 1.1,
                drift: 0,
                ticks: 450,
                origin: { x: originX, y: originY },
                colors: goldColors,
                shapes: ['square', 'circle'],
                scalar: 1.0,
                zIndex: 99999,
                disableForReducedMotion: true
            });
        }

        if (typeof window.confetti === 'function') {
            fire();
        } else {
            // canvas-confetti is loaded with defer from theme.liquid; if it
            // somehow isn't ready, lazy-load it so we still get the moment.
            var s = document.createElement('script');
            s.src = 'https://cdn.jsdelivr.net/npm/canvas-confetti@1.9.3/dist/confetti.browser.min.js';
            s.async = true;
            s.onload = fire;
            document.head.appendChild(s);
        }
    }

    function updateBundleProgressBar() {
        var bar = document.getElementById('bundleProgress');
        if (!bar) return;
        if (bar.hasAttribute('data-static-set-offer')) return;
        var context = bundlePricingContext();
        var info = context.priceState || {
            count: context.pendingPrices.length,
            pendingCount: context.pendingPrices.length,
            freeCount: Math.floor(context.pendingPrices.length / 2),
            needsOne: context.pendingPrices.length % 2 === 1
        };
        var markers = bar.querySelectorAll('.bundle-progress__marker');
        markers.forEach(function (m) {
            var step = parseInt(m.getAttribute('data-bogo-step'), 10);
            var reached = step === 1 ? info.count > 0 : info.count > 0 && !info.needsOne;
            m.classList.toggle('bundle-progress__marker--reached', reached);
            m.classList.toggle('bundle-progress__marker--current', reached && step === 2);
        });

        var fillEl = document.getElementById('bundleProgressFill');
        if (fillEl) fillEl.style.width = info.count === 0 ? '0%' : (info.needsOne ? '50%' : '100%');

        var freeCount = Math.max(0, Number(info.freeCount || 0));
        var pctEl = document.getElementById('bundleProgressPct');
        if (pctEl) pctEl.textContent = info.needsOne ? 'ADD 1 MORE PRODUCT' : freeCount + ' ' + (freeCount === 1 ? 'PRODUCT' : 'PRODUCTS') + ' FREE NOW';
        var nudgeEl = document.getElementById('bundleProgressNudge');
        var statusText;
        if (info.needsOne) {
            statusText = 'ADD 1 MORE PRODUCT. THE LOWER-PRICED ONE WILL BE FREE.';
        } else {
            statusText = freeCount + ' ' + (freeCount === 1 ? 'PRODUCT IS' : 'PRODUCTS ARE') + ' FREE. ADD 2 MORE PRODUCTS FOR ANOTHER FREE.';
        }
        bar.setAttribute('aria-valuetext', statusText);
        if (nudgeEl) nudgeEl.textContent = statusText;

        if (!_bundleProgressInitialized) {
            _bundleProgressInitialized = true;
            _bundleLastFreeCount = info.freeCount;
        } else if (info.freeCount > _bundleLastFreeCount) {
            setTimeout(function () { fireBundleMaxTierConfetti(bar); }, 250);
        }
        _bundleLastFreeCount = info.freeCount;
    }

    function init() {
        swapHeroImage();
        reframeTabs();
        swapBaseNecklaceCard();
        injectPendantSlot();
        collapseEmptyItemContainers();
        overrideAddToCart();
        // Expose refreshBundlePrice on window.Kinsora so theme.js's
        // updatePriceDisplay / updateVariantSelection / updateDisplayedPrice
        // can route through us instead of stomping the bundle price.
        window.Kinsora.refreshBundlePrice = refreshBundlePrice;
        // Initial price render — push it past theme.js's own updatePriceDisplay
        // (which thinks the page is in necklace-only mode and zeroes out the
        // slash/badge). Defer with setTimeout so we run AFTER that handler.
        setTimeout(function () {
            refreshBundlePrice();
            updateBundleProgressBar();
        }, 0);
        // Re-render the BOGO projection and locked bundle cards whenever the
        // pair state changes. Wrap in setTimeout(0) so our listener fires
        // AFTER theme.js's listener on the same event -- otherwise theme.js's
        // necklace-mode logic overwrites our values.
        document.addEventListener('kinsora:stack-updated', function () {
            setTimeout(function () {
                refreshBundlePrice();
                updateBundleProgressBar();
            }, 0);
        });
        document.addEventListener('kinsora:cart-tier-updated', function () {
            setTimeout(function () {
                refreshBundlePrice();
                updateBundleProgressBar();
            }, 0);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
